module.exports = __webpack_public_path__ + "static/banner-update-data-cl-MB-98e64877d97ef8c3d0b32e719f47df94.png";